(function() { module.exports = this["wp"]["editor"]; }());